import React, { useEffect } from "react";

import {
  BrowserRouter,
  Routes,
  Route,
  useParams,
  useLocation,
} from "react-router-dom";

import {
  CartProvider,
} from "./components/CartContext";

import {
  RestaurantSessionProvider,
} from "./components/RestaurantSessionProvider";

import ThemeRouter from "./themes/ThemeRouter";

import KitchenLogin from "./kitchen/KitchenLogin";
import KitchenDashboard from "./kitchen/KitchenDashboard";

import OperationsLogin from "./operations/OperationsLogin";
import OperationsDashboard from "./operations/OperationsDashboard";

import AdminLogin from "./adminDashboard/AdminLogin";
import AdminDashboard from "./adminDashboard/AdminDashboard";

import SuperAdminLogin from "./superadmin/SuperAdminLogin";
import SuperAdminDashboard from "./superadmin/SuperAdminDashboard";


function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


function RestaurantApp() {
  const { restaurantId, tableId } = useParams();

  return (
    <RestaurantSessionProvider
      restaurantId={restaurantId}
      tableId={tableId}
    >
      <CartProvider
        key={restaurantId}
        restaurantId={restaurantId}
      >
        <ThemeRouter />
      </CartProvider>
    </RestaurantSessionProvider>
  );
}


function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        {/* Public restaurant slug: restaurantId variable contains a slug, not a database ID. */}
        <Route
          path="/:restaurantId/table/:tableId/*"
          element={<RestaurantApp />}
        />

        {/* Kitchen login — the route parameter contains the restaurant slug. */}
        <Route
          path="/kitchen/:restaurantId"
          element={<KitchenLogin />}
        />

        {/* Kitchen dashboard */}
        <Route
          path="/kitchen/:restaurantId/dashboard"
          element={<KitchenDashboard />}
        />

        <Route
          path="/operations/:restaurantId"
          element={<OperationsLogin />}
        />

        <Route
          path="/operations/:restaurantId/dashboard"
          element={<OperationsDashboard />}
        />

        <Route
          path="/admin/:restaurantId"
          element={<AdminLogin />}
        />

        <Route
          path="/admin/:restaurantId/dashboard"
          element={<AdminDashboard />}
        />

        <Route
          path="/superadmin/login"
          element={<SuperAdminLogin />}
        />

        <Route
          path="/superadmin/dashboard"
          element={<SuperAdminDashboard />}
        />
        
      </Routes>
    </BrowserRouter>
  );
}


export default App;